import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productListFilter'
})
export class ProductListFilterPipe implements PipeTransform {

  transform(products: any[], text: string): any {
    if (!products || !text) {
        return products;
    }
    return products.filter(product => {
      return (product && product.productType && product.productType.description &&  product.productType.description.toLowerCase().indexOf(text.toLowerCase()) >= 0) ||
        (product && product.planType && product.planType.toLowerCase().indexOf(text.toLowerCase()) >= 0);
    });
  }

}
